import { useContext } from 'react'

import { RentalPortalListingDraft } from '../../RentalPortalListing.context'

import { getListingDraftSaveAction } from './useRentalPortalListingDraft.utils'

export function useRentalPortalListingDraft() {
  const { setDraft, ...draftContext } = useContext(RentalPortalListingDraft)

  function handleSetDraft(nextDraftAction, timeout) {
    setDraft(getListingDraftSaveAction(nextDraftAction), timeout)
  }

  return { ...draftContext, setDraft: handleSetDraft }
}
